// extracted by mini-css-extract-plugin
module.exports = {"tray":"tray_tray__3OIgW","select":"tray_select__20ySa","cameraError":"tray_cameraError__3Xd66"};